const apiUrl = {
  API_URL: process.env.REACT_APP_API_ENDPOINT,
  PROCTORING_API_URL: process.env.REACT_APP_PROCTORING_API_ENDPOINT,
  // The proctoring review room's API; the main API unless an environment serves it elsewhere.
  PROCTORING_REVIEW_API_URL: process.env.REACT_APP_PROCTORING_REVIEW_API_ENDPOINT || process.env.REACT_APP_API_ENDPOINT,
};
export default apiUrl;
